/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finalizeDisputeWon} from '../api'

export const useMutationFinalizeDisputeWon = createReactQueryMutationHook('finalizeDisputeWon', finalizeDisputeWon)
